
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.244 3.041a.746.746 0 00-.488 0l-7.267 2.52a.74.74 0 00-.5.71c.011.73.094 2.004.447 3.496a.744.744 0 001.447-.34 15.478 15.478 0 01-.387-2.648L12 4.524l6.505 2.255a15.476 15.476 0 01-.385 2.65.744.744 0 001.448.338c.35-1.487.432-2.759.443-3.497a.74.74 0 00-.5-.71l-7.267-2.519z"}}),_c('path',{attrs:{"d":"M13.366 7.333c0 .479-.248.9-.623 1.142v1.123c0 .408-.333.74-.743.74a.742.742 0 01-.744-.74V8.474a1.358 1.358 0 01.744-2.5c.754 0 1.366.608 1.366 1.36zM9.152 16.02a.738.738 0 000-1.046.745.745 0 00-1.052 0l-.372.37-.372-.37a.745.745 0 00-1.051 0 .738.738 0 000 1.047l.372.37-.372.37a.738.738 0 000 1.048c.29.289.761.289 1.051 0l.372-.37.372.37c.29.289.761.29 1.051 0a.738.738 0 000-1.047l-.372-.37.373-.371zM13.549 16.02a.738.738 0 000-1.046.745.745 0 00-1.051 0l-.372.37-.372-.37a.745.745 0 00-1.052 0 .738.738 0 000 1.047l.372.37-.371.37a.738.738 0 000 1.048c.29.289.76.289 1.05 0l.373-.37.372.37c.29.289.76.29 1.05 0a.738.738 0 000-1.047l-.371-.37.372-.371zM15.625 16.579a.742.742 0 00-.743.74c0 .409.333.74.743.74h1.625c.41 0 .744-.331.744-.74a.742.742 0 00-.744-.74h-1.625z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.825 11.783A2.82 2.82 0 003 14.596v3.59A2.82 2.82 0 005.825 21h12.35A2.82 2.82 0 0021 18.186v-3.59a2.82 2.82 0 00-2.825-2.813H5.825zm-1.338 2.813c0-.736.599-1.333 1.338-1.333h12.35c.74 0 1.338.597 1.338 1.333v3.59c0 .736-.599 1.333-1.338 1.333H5.825a1.335 1.335 0 01-1.338-1.333v-3.59z"}})])
          )
        }
      }
    